import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useUnitGet } from "hooks/citajteo/dl_unit/useUnitGet";
import { useUnitUpdate } from "hooks/citajteo/dl_unit/useUnitUpdate";
import { QUERY_KEYS } from "constant/react_query";
import toast from "react-hot-toast";
import UnitForm, {
  UnitFormState,
} from "components/admin/common/dl_unit/UnitForm/UnitForm";
import UnitEditNav from "components/admin/common/dl_unit/nav/UnitEditNav";

const EMPTY_FORM: UnitFormState = {
  slug: "",
  uType: "",
  num: "",
  fVals: {},
};

const buildFormFromUnit = (unit: any): UnitFormState => ({
  slug: unit.slug ?? "",
  uType: unit.uType ?? "",
  num: unit.num !== undefined && unit.num !== null ? String(unit.num) : "",
  fVals: unit.fVals ?? {},
});

const DlUnitEdit: React.FC = () => {
  const navigate = useNavigate();
  const { itemId = "" } = useParams<{ itemId: string }>();
  const unit = useUnitGet(itemId);
  const { unitUpdateMutate } = useUnitUpdate({
    invalidateKeysArray: [
      [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
      [QUERY_KEYS.CITAJTEO_DL_UNIT_GET, itemId],
    ],
  });
  const {
    control,
    handleSubmit: handleFormSubmit,
    reset,
  } = useForm<UnitFormState>({ defaultValues: EMPTY_FORM });
  const [errorText, setErrorText] = useState("");

  useEffect(() => {
    if (unit) {
      reset(buildFormFromUnit(unit));
    }
  }, [reset, unit]);

  const handleSubmit = (form: UnitFormState) => {
    setErrorText("");

    const trimmedSlug = form.slug.trim();
    if (trimmedSlug === "") {
      setErrorText("Slug ne sme biti prazan.");
      return;
    }

    const parsedNum = Number(form.num);
    if (Number.isNaN(parsedNum)) {
      setErrorText("Broj mora biti numerička vrednost.");
      return;
    }

    unitUpdateMutate(
      {
        id: itemId,
        updatePayload: {
          slug: trimmedSlug,
          uType: form.uType.trim(),
          num: parsedNum,
          fVals: form.fVals,
        },
      },
      {
        onSuccess: () => {
          toast.success("Uspešno ažuriranje jedinice.");
          navigate("/admin-dashboard/dl-unit-li");
        },
        onError: (error) => {
          console.error("Error updating unit:", error);
          toast.error("Greška prilikom ažuriranja jedinice.");
        },
      },
    );
  };

  const handleReset = () => {
    if (unit) {
      reset(buildFormFromUnit(unit));
    } else {
      reset(EMPTY_FORM);
    }
    setErrorText("");
  };

  if (!unit) {
    return <Div>Učitavanje jedinice...</Div>;
  }

  return (
    <Div>
      <UnitEditNav unit={unit} />
      <UnitForm
        control={control}
        errorText={errorText}
        onSubmit={handleFormSubmit(handleSubmit)}
        onReset={handleReset}
      />
    </Div>
  );
};

export default DlUnitEdit;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
